export var createGeolocation = function createGeolocation(emitNotSupportedError, window, wrapSubscribeFunction) {
  return function (options) {
    return wrapSubscribeFunction(function (observer) {
      if (window === null || window.navigator === undefined || window.navigator.geolocation === undefined || window.navigator.geolocation.clearWatch === undefined || window.navigator.geolocation.watchPosition === undefined) {
        return emitNotSupportedError(observer);
      }

      var watchId = window.navigator.geolocation.watchPosition(function (position) {
        return observer.next(position);
      }, function (err) {
        return observer.error(err);
      }, options);
      return function () {
        return window.navigator.geolocation.clearWatch(watchId);
      };
    });
  };
};